import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JoyrideModule } from 'ngx-joyride';
import { GuiderComponent } from './guider.component';

@NgModule({
  declarations: [GuiderComponent],
  imports: [CommonModule,
    JoyrideModule.forRoot()
    ],
    exports: [GuiderComponent]
})
export class GuiderModule {}
